<template>
  <c-modal :show="show" class="view-asset" title="New Asset" size="xl" @update:show="close">
    <c-row>
      <c-col sm="12" md="4">
        <c-input
            :value="asset.licenceName"
            label="Asset name"
            type="text"
            readonly
        />
        <c-input
            :value="asset.entityType"
            label="Asset type"
            type="text"
            readonly
        />
        <template v-if="asset.sites.length">
          <label>Sites</label>
          <div v-if="asset.sites.length" class="ml-3 mb-3">
            <c-row class="mb-1" v-for="(site, i) in asset.sites" :key="`site_${i}`">
              <c-col sm="12">{{site.name}}</c-col>
            </c-row>
          </div>
        </template>
        <template v-if="asset.clients.length">
          <label>Clients</label>
          <div v-if="asset.clients.length" class="ml-3 mb-3">
            <c-row class="mb-1" v-for="(client, i) in asset.clients" :key="`site_${i}`">
              <c-col sm="12">{{client.name}}</c-col>
            </c-row>
          </div>
        </template>
      </c-col>
      <c-col sm="12" md="4">
        <c-input
            :value="asset.licenceStartDate | dateFormatSimple"
            label="Asset Start Date"
            readonly
        />
        <c-input
            :value="asset.licenceRenewDate | dateFormatSimple"
            label="Asset End Date"
            type="text"
            readonly
        />
        <template v-if="asset.assetHasCredentials">
          <c-input
              :value="asset.credentials.username"
              label="Username"
              type="text"
              readonly
          />
          <c-input
              :value="asset.credentials.password"
              label="Password"
              type="password"
              readonly
          />
          <c-input
              :value="asset.assetUrl"
              label="Asset URL"
              type="text"
              readonly
          />
        </template>
      </c-col>
      <c-col sm="12" md="4">
        <c-input
            :value="asset.assetHasLicence ? 'Yes' : 'No'"
            label="Does this asset have a licences?"
            type="text"
            readonly
        />
        <template v-if="asset.assetHasLicence === 'y'">
          <c-input
              :value="asset.licenceSeats"
              label="Number of licences"
              type="text"
              readonly
          />
        </template>
        <c-input
            :value="asset.assetPurchased ? 'Yes' : 'No'"
            label="Is this asset purchased?"
            type="text"
            readonly
        />
      </c-col>
    </c-row>

    <template v-slot:footer>
      <c-button-group>
        <c-button color="secondary" @click="close">Close</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>

export default {
  name: 'CreateAsset',
  props: {
    show: Boolean,
    asset: Object,
  },
  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
